const MAIL_SERVER = {
    GMAIL: 'gmail',
    OUTLOOK: 'outlook',
    OTHER: 'other'
};

export default MAIL_SERVER;